<div class="scheduleRequestModal">
  <p-dialog [(visible)]="displayComponent"
            [header]="('SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.SCHEDULING_COMPONENT.MODAL_TITLE' | translate) + activeRequest.requestName"
            [draggable]="false"
            [closable]="true"
            [resizable]="false"
            [modal]="true" [closeOnEscape]="false"
            (onHide)="hideScheduleRequestModal( false )">

    <!--Validation button-->
    <div class="col-12 center">
      <div class="col-6 center scheduleRequestModal_exec-button">
        <button pButton type="button" [icon]="'fa fa-file-excel-o'" class="p-button-success"
                (click)="execute()"
                [label]="'SEARCH_COMPONENT.FORM.BUTTON_EXECUTE' | translate" [disabled]="!formIsValid()">
        </button>
      </div>
      <div class="col-6 center scheduleRequestModal_validation-button">
        <button pButton type="button" [icon]="'fa fa-clock-o'" class="p-button-success" (click)="save()"
                [label]="'SEARCH_COMPONENT.FORM.BUTTON_UPDATE' | translate" [disabled]="!formIsValid()">
        </button>
      </div>
    </div>
    <div style="clear: both;"></div>
    <div class="col-12">
    <div class="col-6">
    </div>
    <div class="col-6">
    <p-fieldset
      legend="{{'SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.SCHEDULING_COMPONENT.EXTRACTION_LABEL' | translate}}">
      <div class="grid">
        <!--Columns filtering-->
        <div class="col-12" [ngClass]="{'notValidContainer': selectedColumns.length===0}">
          <p-listbox [options]="columnsList" [(ngModel)]="selectedColumns" [multiple]="true"
                     [checkbox]="true"
                     [filter]="true" (onChange)="reorderList()">
          </p-listbox>
        </div>
      </div>
    </p-fieldset>
    </div>
    </div>
    <p-fieldset
      legend="{{'SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.SCHEDULING_COMPONENT.PLAN' | translate}}">
      <div class="grid">
        <!--Period & wished extraction-->
        <div class="col-12">
          <!--Period-->
          <div>
            <h3>{{'SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.SCHEDULING_COMPONENT.PERIODICITY_LABEL' | translate}}</h3>
            <p-selectButton #frequency_options [options]="schedulingOptions"  [ngModel]="selectedSchedulingOption"
                            (onOptionClick)="setIsSelectedFrequency( $event)"></p-selectButton>
          </div>
        </div>
      </div>

      <ng-container *ngIf="isSelectedFrequency">
        <div class="grid">
          <div class="col-12">
            <!--Email list-->
            <div class="col-6">
              <h3>{{'SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.SCHEDULING_COMPONENT.EMAIL_ADDRESS_LABEL' | translate}}</h3>

              <!--Email list-->
              <div class="emailList">
                <!--Display list of seized email-->
                <div *ngFor="let email of emailList">
                  <div class="col-11">
                    <input type="text" pInputText [ngModel]="email" disabled/>
                  </div>
                  <div class="col-1">
                    <button pButton type="button" [icon]="'fa fa-trash'" (click)="removeEmail(email)"
                            class="p-button-danger">
                    </button>
                  </div>
                </div>

                <!--New email-->
                <div>
                  <div class="col-11">
                    <input [ngClass]="{'notValid': emailList.length===0 && newEmail.length===0}" type="text" pInputText
                           [(ngModel)]="newEmail"/>
                  </div>
                  <div class="col-1">
                    <button pButton type="button" [icon]="'fa fa-plus'" (click)="addNewEmail()"
                            [disabled]="!newEmailIsValid()"
                            class="p-button-success">
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!--Wished extraction-->
            <div class="col-6">
              <div>
                <h3>{{'SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.SCHEDULING_COMPONENT.EXTRACTION_LABEL' | translate}}</h3>
                <div class="col-6" *ngFor="let option of extractionOptions">
                  <p-checkbox [label]="option.label" [value]="option.value" [(ngModel)]="selectedExtractionOption">
                  </p-checkbox>
                </div>
              </div>
              <div>
                <!--Batch Textarea -->
                <div class="col-12">
                  <h3>{{'SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.SCHEDULING_COMPONENT.BATCH_PARAMETERS_LABEL' | translate}}</h3>
                  <textarea [ngClass]="{'notValid': batchisSelected() && batchContent.length===0}" pInputTextarea
                            [disabled]="!batchisSelected()" [(ngModel)]="batchContent">
              </textarea>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="grid">
          <!--Columns filtering, Batch and email-->

        </div>
      </ng-container>
    </p-fieldset>

    <!--Detected problems-->
    <div class="col-12"
         *ngIf="selectedColumns.length === 0 ||
            ( selectedSchedulingOption || ( batchisSelected() && batchContent.length === 0 ) ) ||
            ( selectedSchedulingOption && emailList.length === 0 )">
      <p-fieldset
        [legend]=" 'SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.SCHEDULING_COMPONENT.DETECTED_PROBLEMS_LABEL' | translate ">
        <ul>
          <!--            <li *ngIf="!selectedSchedulingOption">
                        {{ 'SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.SCHEDULING_COMPONENT.PROBLEMS.PERIOD_ERROR' |
                        translate }}
                      </li>-->
          <li *ngIf="selectedColumns.length===0">
            {{ 'SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.SCHEDULING_COMPONENT.PROBLEMS.COLUMNS_ERROR' |
            translate }}
          </li>
          <ng-container *ngIf="selectedSchedulingOption">
            <li *ngIf="batchisSelected() && batchContent.length===0">
              {{ 'SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.SCHEDULING_COMPONENT.PROBLEMS.BATCH_ERROR' |
              translate }}
            </li>
            <li *ngIf="emailList.length===0">
              {{ 'SAVED_REQUEST.ADD.OR.UPDATE.SAVED.REQUEST_COMPONENT.SCHEDULING_COMPONENT.PROBLEMS.EMAIL_ERROR' |
              translate }}
            </li>
          </ng-container>

        </ul>
      </p-fieldset>
    </div>
  </p-dialog>
</div>
